import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Divider, Grid, InputLabel, Paper } from "@mui/material";
import { borderRadius } from "@mui/system";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useDispatch } from "react-redux";
import { register } from "../../Redux/actions";
import { useSignupMutation } from "../../api/signup";
import Swal from "sweetalert2";

export default function Register() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [signup, { isLoading }] = useSignupMutation();

  const Root = styled("div")(({ theme }) => ({
    width: "100%",
    ...theme.typography.body2,
    "& > :not(style) + :not(style)": {
      marginTop: theme.spacing(2),
    },
  }));

  const handleAPIhit = () => {
    signup({ fullName, email, phone }).then((res) => {
      if (res.error) return Swal.fire("Failed!", res.error.data.message);
      Swal.fire("Success", res.data.message, "success").then(() => {
        navigate("/login");
      });
    });
  };

  return (
    <>
      <Box
        bgcolor="#F9FFFF"
        sx={{
          display: { lg: "block", md: "block", sm: "block", xs: "block" },
          backgroundImage: "url(./images/IllustrationsBg.svg)",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "auto",
          // height: "100vh",
          backgroundSize: {
            xl: "cover",
            lg: "contain",
            md: "contain",
            sm: "contain",
          },
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          margin: "0px",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            padding: "20px",
            mt: "80px",
          }}
        >
          <Grid item xl={7} lg={6} md={6} sm={6} xs={false}>
            <Box></Box>
          </Grid>

          <Grid
            item
            xl={5}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            component={Paper}
            elevation={6}
            square
            // display="flex"
            // flexDirection={"column"}
            // justifyContent="center"
            // alignItems="flex-end"
            // alignSelf= "flex-end"
            // mt={{ lg: "165px", md: "165px" }}
            // ml={"842px"}
            // paddingLeft="24px"
            // ml={"680px"}
            // mr={"72px"}
            // width={"526px"}
            // className="frame"
            // alignItem={"flex-end"}
            // alignContent={"flex-end"}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box>
                <Button
                  sx={{
                    // p: 1,
                    border: '1px solid #e1e1e6',
                    borderRadius: "5px",
                    display: "inline",
                    // my: 1,/
                  }}
                  onClick={() => navigate("/")}
                >
                  &larr;
                </Button>
                <Typography
                  className="title"
                  sx={{
                    fontFamily: "Outfit",
                    fontSize: "40px",
                    fontWeight: "600",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  Welcome to Eatcoast
                </Typography>

                <Typography
                  mt="8px"
                  mb="20px"
                  className="titleParagraph"
                  sx={{ textAlign: "center" }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting <br /> industry
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItem: "center",
                  justifyContent: "center",
                  // border: "1px solid red",
                }}
              >
                <Box>
                  <Button
                    variant="outlined"
                    className="googleBtn"
                    sx={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      // marginLeft: "139px",
                      marginRight: "20px",
                    }}
                  >
                    <img
                      src="./images/Google.svg"
                      alt=""
                      sx={{
                        width: "16.83px",
                        border: "solid",
                        borderWidth: "1px",
                      }}
                    />
                  </Button>
                </Box>

                <Box>
                  <Button
                    variant="outlined"
                    className="appleBtn"
                    sx={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      marginRight: "20px",
                    }}
                  >
                    <img
                      src="./images/Apple.svg"
                      alt=""
                      sx={{
                        width: "16.83px",
                        border: "solid",
                        borderWidth: "1px",
                      }}
                    />
                  </Button>
                </Box>

                <Box>
                  <Button
                    variant="outlined"
                    className="facebookBtn"
                    sx={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src="./images/Facebook.svg"
                      alt=""
                      sx={{
                        width: "16.83px",
                        border: "solid",
                        borderWidth: "1px",
                      }}
                    />
                  </Button>
                </Box>
              </Box>

              <Box sx={{ marginTop: "20px" }}>
                <Root>
                  <Divider textAlign="center" flexItem="true" color="#E1E1E6">
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Outfit",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "18px",
                          lineHeight: "145%",
                          /* or 26px */

                          textAlign: "center",
                          letterSpacing: "0.015em",

                          /* Base/Subtle */

                          color: "#9EA3AE",
                        }}
                      >
                        or
                      </Typography>
                    </Box>
                  </Divider>
                </Root>
              </Box>

              <Box sx={{ marginTop: "33px", width: "96%" }}>
                <InputLabel
                  className="inputlabel"
                  sx={{
                    fontSize: "20px",
                    color: "#1a1824",
                    fontWeight: "500",
                  }}
                >
                  Full name
                </InputLabel>
                <Box
                  sx={{
                    width: "100%",
                    // maxWidth: "100%",
                  }}
                >
                  <TextField
                    className="inputfield"
                    fullWidth
                    label="Enter your full name"
                    id="name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </Box>
              </Box>

              <Box sx={{ marginTop: "24px", width: "96%" }}>
                <InputLabel
                  className="inputlabel"
                  sx={{
                    fontSize: "20px",
                    color: "#1a1824",
                    fontWeight: "500",
                  }}
                >
                  Email
                </InputLabel>
                <Box
                  sx={{
                    width: "100%",
                    // maxWidth: "100%",
                  }}
                >
                  <TextField
                    className="inputfield"
                    fullWidth
                    label="Enter your email address"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Box>
              </Box>

              <Box sx={{ marginTop: "24px", width: "96%" }}>
                <InputLabel
                  className="inputlabel"
                  sx={{
                    fontSize: "20px",
                    color: "#1a1824",
                    fontWeight: "500",
                  }}
                >
                  Phone Number
                </InputLabel>
                <Box
                  sx={{
                    width: "100%",
                    // maxWidth: "100%",
                  }}
                >
                  <TextField
                    marign="normal"
                    className="inputfield"
                    fullWidth
                    type="number"
                    label="+1 XXXX XXXX XXXX"
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Box>
              </Box>
            </Box>

            <Box sx={{ p: 1 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#2B817B",
                  height: "48px",
                  color: "#FFFFFF",
                  fontSize: "16px",
                  fontWeight: "600",
                  textTransform: "capitalize",
                  letterSpacing: "0.015em",
                  width: "99%",
                  marginTop: "16px",
                  borderRadius: "6px",
                }}
                onClick={handleAPIhit}
              >
                Create Account
              </Button>

              <Box>
                <Typography
                  className="typoLine"
                  sx={{
                    display: "flex",
                    alignItem: "center",
                    justifyContent: "center",
                    marginTop: "48px",
                    marginBottom: "24px",
                  }}
                >
                  Already have an account ? &nbsp;{" "}
                  <Link to="/login" style={{ color: "#2B817B" }}>
                    Sign in
                  </Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
